/**
 * Toggle Section Header
 *
 */
export const toggleSectionHeader = () => {

	const menu = document.querySelector( '.js-c-page-header' );

	if ( menu ) {

		menu.addEventListener( 'click', () => {

			if ( window.matchMedia( '(max-width: 1140px)' ).matches ) {

				const nav = menu.querySelector( '.c-page-header__nav' );

				menu.classList.toggle( 'c-page-header--opened' );

				if ( nav ) {

					if ( menu.classList.contains( 'c-page-header--opened' ) ) {

						nav.style.maxHeight = `${ nav.scrollHeight }px`;

					} else {

						nav.style.maxHeight = '';

					}

				}

			}

		} );

	}

}
